import React from 'react';
import icon from '../../assets/images/shawnipedia.png';

const Logo = () => {
  return <img src={icon} className='logo' alt='Icon'/>
}

export default Logo;